"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { shopifyIllustratedServices, ShopifyIllustratedServiceCard } from "./shopify.data";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface ShopifyStepsShowcaseProps {
  heading?: string;
  subtitle?: string;
  services?: ShopifyIllustratedServiceCard[];
  buttonText?: string;
  buttonHref?: string;
  className?: string;
}
export default function ShopifyStepsShowcase(t0) {
  const $ = _c(32);
  const {
    heading: t1,
    subtitle: t2,
    services: t3,
    className: t4
  } = t0;
  const heading = t1 === undefined ? "Hire our Shopify Developers for End-to-End Services" : t1;
  const subtitle = t2 === undefined ? "Bring your business to the online market in full fledge with custom Shopify development services from The Dezine. Hire pre-vetted Shopify experts to leverage their years of business expertise in developing custom Shopify solutions for your business." : t2;
  const services = t3 === undefined ? shopifyIllustratedServices : t3;
  const className = t4 === undefined ? "" : t4;
  const desktopAnimations = useDesktopAnimations();
  const t5 = `relative overflow-hidden bg-[linear-gradient(120deg,#eefbf8_0%,#f6f8fd_45%,#f2eefc_100%)] px-6 py-16 font-sans md:py-24 transition-colors duration-300 dark:bg-[#070b14] dark:bg-none ${className}`;
  let t6;
  if ($[0] !== desktopAnimations) {
    t6 = desktopAnimations ? {
      opacity: 0,
      y: 40
    } : false;
    $[0] = desktopAnimations;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== desktopAnimations) {
    t7 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== desktopAnimations) {
    t8 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t10;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      duration: 0.6,
      ease
    };
    t10 = {
      once: true
    };
    $[6] = t10;
    $[7] = t9;
  } else {
    t10 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] !== heading || $[9] !== t6 || $[10] !== t7 || $[11] !== t8) {
    t11 = <motion.h2 initial={t6} whileInView={t7} animate={t8} transition={t9} viewport={t10} className="mb-5 font-poppins text-[1.9rem] font-bold leading-tight text-[#0b1354] sm:text-[2.25rem] lg:text-[2.6rem] dark:text-white">{heading}</motion.h2>;
    $[8] = heading;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== desktopAnimations || $[14] !== subtitle) {
    t12 = subtitle && <motion.p initial={desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false} whileInView={desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined} animate={desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6,
      delay: 0.1,
      ease
    }} viewport={{
      once: true
    }} className="text-base leading-[1.75] text-[#5b6b7d] dark:text-gray-400">{subtitle}</motion.p>;
    $[13] = desktopAnimations;
    $[14] = subtitle;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== t11 || $[17] !== t12) {
    t13 = <div className="mx-auto mb-14 max-w-3xl text-center">{t11}{t12}</div>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== desktopAnimations || $[20] !== services) {
    let t15;
    if ($[22] !== desktopAnimations) {
      t15 = (service, idx) => {
        const panelGradient = idx % 2 === 0 ? "bg-gradient-to-b from-[#d9b0ea] to-[#fcdfe6] dark:from-[#351e44] dark:to-[#40233b]" : "bg-gradient-to-b from-[#fce0e6] to-[#d5a8e8] dark:from-[#40233b] dark:to-[#351e44]";
        return <motion.div key={service.id} initial={desktopAnimations ? {
          opacity: 0,
          y: 30
        } : false} whileInView={desktopAnimations ? {
          opacity: 1,
          y: 0
        } : undefined} animate={desktopAnimations ? undefined : {
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: idx % 3 * 0.1,
          ease
        }} viewport={{
          once: true
        }} className="h-full flex flex-col"><article className="group relative h-full flex flex-col overflow-hidden rounded-[14px] bg-white shadow-[0_10px_40px_-18px_rgba(13,38,76,0.25)] transition-all duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] hover:-translate-y-[7.5px] hover:shadow-[0_20px_45px_rgba(20,50,90,0.12)] border border-gray-100/60 dark:border-gray-800 dark:bg-[#111625] dark:shadow-none"><div className={`relative w-full overflow-hidden aspect-[4/3] flex items-center justify-center p-5 sm:p-6 ${panelGradient}`}><Image src={service.image} alt={service.alt} width={400} height={300} loading="lazy" className="h-full w-full object-contain drop-shadow-sm transition-transform duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:scale-105" onError={_temp} /></div><div className="px-7 pb-9 pt-6 flex-1 flex flex-col"><h3 className="mb-2 font-poppins text-[1.35rem] font-bold leading-snug text-[#0b1354] dark:text-white">{service.title}</h3>{service.subtitle && <p className="mb-4 text-[14.5px] leading-[1.6] text-[#5b6b7d] dark:text-gray-300 font-sans">{service.subtitle}</p>}{service.points && service.points.length > 0 && <ul className="mt-auto space-y-2.5 font-sans text-[14px] leading-[1.65] text-[#5b6b7d] dark:text-gray-300">{service.points.map(_temp2)}</ul>}</div><span aria-hidden={true} className="absolute bottom-0 left-0 h-1 w-0 bg-[linear-gradient(135deg,#9100ff_0%,#3663ff_54%,#00e2ff_100%)] transition-[width] duration-[1200ms] ease-[cubic-bezier(0.17,0.85,0.438,0.99)] group-hover:w-full" /></article></motion.div>;
      };
      $[22] = desktopAnimations;
      $[23] = t15;
    } else {
      t15 = $[23];
    }
    t14 = services.map(t15);
    $[19] = desktopAnimations;
    $[20] = services;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[24] !== t14) {
    t15 = <div className="grid grid-cols-1 gap-7 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">{t14}</div>;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t13 || $[27] !== t15) {
    t16 = <div className="mx-auto w-full max-w-7xl">{t13}{t15}</div>;
    $[26] = t13;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t16 || $[30] !== t5) {
    t17 = <section className={t5}>{t16}</section>;
    $[29] = t16;
    $[30] = t5;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
}
function _temp2(point, pointIdx) {
  return <li key={pointIdx} className="flex items-start gap-2"><span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#5b6b7d] dark:bg-gray-400" /><span>{point}</span></li>;
}
function _temp(e) {
  e.currentTarget.onerror = null;
}